import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { TOAST_ERROR } from "../../utils/common.service";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import Cookies from "js-cookie";

export default function TurnamentLeaderboard() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [userDetails, setUserDetails] = useState([]);
  const clientData = location?.state?.clientData;
  let navigate = useNavigate();
 // console.log("clientData -------------------:", clientData);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        let request = {
          id: clientData?.id,
          search: debounce,
          page: page,
        };
        dispatch(setLoader(true));
        const response = await API.tournamentLeaderboardApi(request);
        //console.log("response of api ", response);

        if (response?.code == "1") {
          setUserDetails(response?.data);
        } else {
          setUserDetails([]);
        }
        dispatch(setLoader(false));
      } catch (error) {
        //console.log("8888888888888888888888888888888",error);

        dispatch(setLoader(false));
        //TOAST_ERROR("Failed to load User Details");
      }
    };

    fetchUser();
  }, [page, debounce]);

  const userListData = useMemo(() => {
    return userDetails?.map((item, index) => (
      <tr key={index}>
        <td>{index+1}</td>
        <td>{item?.static_rank}</td>
        <td>
          <img
            src={item?.profile_image}
            alt="Profile Picture"
            style={{ width: "50px", height: "50px", objectFit: "contain" }}
          />
        </td>
        <td>{item?.first_name + " " + item?.last_name || "-"}</td>
        <td>{item?.points || "-"}</td>
        <td>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() =>
              navigate(`/manage_tournament/view_user_details`, {
                state: { clientData: item },
              })
            }
          >
            <i className="ri-eye-line"></i>
          </a>
        </td>
      </tr>
    ));
  }, [userDetails]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Tournament Leaderboard`} header={`TOURNAMENT`} />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`User`}
                  setSearch={setSearch}
                  isExport={false}
                  // handleExportApiCall={handleExportApiCall}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {userDetails.length > 0 ? (
                      <table
                        id="user-table"
                        className="table table-centered mb-0 table-hover"
                      >
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Rank</th>
                            <th>Profile Picture</th>
                            <th>Name</th>
                            <th>Total Points</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>{userListData}</tbody>
                      </table>
                    ) : (
                      <>{handleNoDataFound("Users")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={userDetails[0]?.user_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Users`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
